/**
 * The two answers the platform gives when an organization the session names cannot be used here
 * (`fastify-common` `organizationMembership.ts`, specs/world-authoritative-organizations.md):
 *
 * - `organization_not_in_world` (403 from an org-scoped route, 404 from `provisioning-status`):
 *   the person has no membership in that organization in this environment. Retrying cannot help.
 * - `organization_membership_unavailable` (503): the membership could not be checked just now.
 *   Retrying can help.
 */
export const ORGANIZATION_NOT_IN_WORLD = 'organization_not_in_world';
export const ORGANIZATION_MEMBERSHIP_UNAVAILABLE = 'organization_membership_unavailable';

export type OrganizationMembershipFailure = 'not-in-world' | 'membership-unavailable';

interface HttpLikeError {
  response?: { status?: number; data?: { error?: unknown } };
}

/** The `error` code an HTTP failure carries in its body, or null. */
export function errorCodeOf(error: unknown): string | null {
  const code = (error as HttpLikeError | null)?.response?.data?.error;
  return typeof code === 'string' ? code : null;
}

/** Which membership answer `error` (an axios error) is, or null when it is neither. */
export function organizationMembershipFailure(error: unknown): OrganizationMembershipFailure | null {
  return membershipFailureFromCode(errorCodeOf(error));
}

/** The same, from an error code already read off a response. */
export function membershipFailureFromCode(code: string | null | undefined): OrganizationMembershipFailure | null {
  if (code === ORGANIZATION_NOT_IN_WORLD) return 'not-in-world';
  if (code === ORGANIZATION_MEMBERSHIP_UNAVAILABLE) return 'membership-unavailable';
  return null;
}
